var React = require('react');

function CardTop (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M525 0H0V65.0164C0.119141 65.0086 0.239136 65.0035 0.359741 65.0013C0.406372 65.0004 0.453125 65 0.5 65C4.64209 65 8 68.3578 8 72.5C8 76.6422 4.64209 80 0.5 80C0.332031 80 0.165283 79.9945 0 79.9836V88H525V79.9836C524.835 79.9945 524.668 80 524.5 80C520.358 80 517 76.6422 517 72.5C517 68.3578 520.358 65 524.5 65C524.668 65 524.835 65.0055 525 65.0164V0Z","fill":"white"}));
}

CardTop.defaultProps = {"viewBox":"0 0 525 88","fill":"none"};

module.exports = CardTop;

CardTop.default = CardTop;
